// MpfSummaryList.props.ts
// NHS DS: https://service-manual.nhs.uk/design-system/components/summary-list

export interface MpfSummaryListAction {
  href: string;
  text: string;
  visuallyHiddenText?: string;
}

export interface MpfSummaryListRow {
  key: string;
  value: string;
  actions?: MpfSummaryListAction[];
  noBorder?: boolean;
}

export interface MpfSummaryListProps {
  rows: MpfSummaryListRow[];
  noBorder?: boolean;
}

export const mpfSummaryListDefaults = {
  noBorder: false,
} satisfies Partial<MpfSummaryListProps>;
